module.exports = __webpack_public_path__ + "img/lsof_output.8bd195a2.png";